<template>
    <div class="TemplateTab p-3">
        <div class="SearchArea">
            <input type="search" class="form-control rounded-pill h-45px" placeholder="Search ... " />
        </div>
        <div class="imagsGallery">
            <h5 class="text-muted py-2">Recent templates</h5>
            <a href="javascript:;" @click="addInCanvas"><img src="../../assets/test.jpg" class="img-fluid" /></a>
        </div>
    </div>
</template>

<script>
import { fabric } from 'fabric';
    export default {
        name:"TemplateTab",
        computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
    },
        methods:{
            addInCanvas(){

                // let url = "/vecteezy_chef-logo-vector-text-style_7576703.svg";
                let url = "/test.svg";
                let canvas = this.getActiveCanvas;
                fabric.loadSVGFromURL(url,
                (objects, options) => {
                    var group = new fabric.Group(objects, options);
                    group.set({
                        scaleX: canvas.width / group.width,
                     scaleY: canvas.height / group.height
                    });
                  
                    
                    // var items = group._objects;
                    // group._restoreObjectsState();
            
                    // for (let i = 0; i < items.length; i++) {
                    //     canvas.add(items[i]);
                    // }
                    canvas.add(group)
                    group.setCoords()

                        // canvas.calcOffset();

                    canvas.renderAll();
                });

            }
        }
    }
</script>
<style scoped>
    .h-45px{
        height: 45px;
    }
    .imagsGallery h5{
        letter-spacing: .1em;
        font-size: 15px;

    }
</style>